import React from "react";
import "./Modal.scss";

interface BaseModalProps {
  open: boolean;
  onClose: () => void;
  onOpen: () => void; 
  leftOffset?: number;
  headerText: string;
  children: React.ReactNode;
  className?: string;
}

export const BaseModal: React.FC<BaseModalProps> = ({
  open,
  onClose,
  onOpen,
  leftOffset = 50,
  headerText,
  children,
  className = ""
}) => {
  return (
    <div 
      className={`base-modal ${className} ${open ? "open" : "closed"}`} 
      style={{ left: `${leftOffset}px` }}
    >
      <div className="modal-header" onClick={open ? onClose : onOpen}>
        <span>{open ? `${headerText}` : `${headerText}`}</span>
        <i className={`fa ${open ? "fa-chevron-down" : "fa-chevron-up"}`}></i>
      </div>
      {open && <div className="modal-content">{children}</div>}
    </div>
  );
};
